import { css } from "../helpers/webComponents";

const styles: string = css`
  :host {
    background-color:rgb(32, 33, 38);
    border-radius: 10px;
    color: white;
    display: flex;
    flex-direction: column;
    padding: 20px;
    position: fixed;
    z-index: 1;
    top: 40%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: auto;
    height: auto;
    box-sizing: border-box;
  }
  
  .header {
    font-size: 1.2em;
    margin-bottom: 10px;
    text-align: center;
  }
  
  .display {
    width: auto;
    background-color: gray;
    color: white;
    font-size: 1.5em;
    padding: 10px;
    text-align: center;
    margin-bottom: 10px;
    border-radius: 5px;
  }
  
  .keypad {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 10px;
    margin-bottom: 10px;
  }
  
  .key {
    padding: 15px;
    background-color: darkgray;
    border: none;
    color: white;
    font-size: 1.2em;
    border-radius: 5px;
    cursor: pointer;
    transition: background-color 0.2s ease;
  }
  
  .key:hover {
    background-color:rgb(95, 100, 106);
  }
  
  .controls {
    display: flex;
    justify-content: space-between;
  }
  
  .control-button {
    padding: 15px 20px;
    background-color: black;
    border: none;
    color: white;
    font-size: 1.2em;
    border-radius: 5px;
    cursor: pointer;
    transition: background-color 0.2s ease;
    flex: 1;
    margin: 0 5px;
  }
    
  .control-button#enter-btn {
    background-color: green;
  }

   .control-button#delete-btn {
    background-color: red;
  }
  
  .control-button:hover {
    background-color: #78808D;
  }
`;

export class NumericLockComponent extends HTMLElement {
    // Define the correct code (adjust as needed).
    private correctCode: string = "25134";
    // Holds the current input string.
    private currentInput: string = "";

    public constructor() {
        super();
        this.attachShadow({ mode: "open" });
    }

    public connectedCallback(): void {
        this.render();
    }

    /**
   * Appends a digit to the current input if fewer than 5 digits are entered.
   * @param key - The pressed digit as a string.
   */
    private handleKeyPress(key: string): void {
        if (this.currentInput.length < 5) {
            this.currentInput += key;
            this.render();
        }
    }

    /**
   * Removes the last character from the current input.
   */
    private handleDelete(): void {
        this.currentInput = this.currentInput.slice(0, -1);
        this.render();
    }

    /**
   * Checks the entered code when the Enter button is pressed.
   * If correct, dispatches a "password-success" event and hides the component.
   * Otherwise, alerts the user and clears the input.
   */
    private handleEnter(): void {
        if (this.currentInput === this.correctCode) {
            this.dispatchEvent(
                new CustomEvent("password-success", { bubbles: true, composed: true })
            );
            this.style.display = "none";
        }
        else {
            alert("Incorrect code. Please try again.");
            this.currentInput = "";
            this.render();
        }
    }

    private render(): void {
        if (!this.shadowRoot) return;
        // Show the current input with underscores for unfilled digits.
        const displayText: string = this.currentInput.padEnd(5, "_");
        this.shadowRoot.innerHTML = `
      <style>${styles}</style>
      <div class="header">Enter the 5-digit code:</div>
      <div class="display">${displayText}</div>
      <div class="keypad">
        ${[1, 2, 3, 4, 5, 6, 7, 8, 9, 0].map(num => `
          <button class="key" data-key="${num}">${num}</button>
        `).join("")}
      </div>
      <div class="controls">
        <button class="control-button" id="delete-btn">Delete</button>
        <button class="control-button" id="enter-btn">Enter</button>
      </div>
    `;
        // Attach event listeners for digit buttons.
        this.shadowRoot.querySelectorAll("button.key").forEach(button => {
            const key: string = button.getAttribute("data-key")!;
            button.addEventListener("click", () => this.handleKeyPress(key));
        });
        // Attach event listener for the Delete button.
        this.shadowRoot.querySelector("#delete-btn")?.addEventListener("click", () => this.handleDelete());
        // Attach event listener for the Enter button.
        this.shadowRoot.querySelector("#enter-btn")?.addEventListener("click", () => this.handleEnter());
    }
}

customElements.define("numeric-lock", NumericLockComponent);
